import { render } from "./ClientRequestsAnalyticsCard.vue?vue&type=template&id=37395761"
import script from "./ClientRequestsAnalyticsCard.vue?vue&type=script&lang=js"
export * from "./ClientRequestsAnalyticsCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__